import { type SearchProductDataDTO } from "~/features/search/models/SearchResultsDTO";
import { type SrpProductData } from "~/utils/models";
import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";
import { resolveUrl } from "~/utils/url/urlResolver";

import { TabId } from "~/features/productDetails/components/usePDPTabs";

export function transformSrpProduct(dto: SearchProductDataDTO): SrpProductData {
  const base = transformProduct(dto);

  let cadUrl = undefined;
  let calcUrl = undefined;
  if (dto.url) {
    const url = new URL(window.location.origin);
    url.pathname = resolveUrl(dto.url);

    url.hash = TabId.CAD_DATA;
    cadUrl = url.toString();
    if (dto?.hasCalc) {
      url.hash = TabId.CALCULATION;
      calcUrl = url.toString();
    }
  }

  return {
    ...base,
    cadUrl,
    calcUrl,
    hasCad: dto.hasCad,
  };
}
